import React, { useState, useEffect, useRef } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Box,
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import ZJ from "./Images/Logos/ZJ.png";
import MenuDrawer from "./MenuDrawer";
import "./CSS/Navbar.css";
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [openProjects, setOpenProjects] = useState(false);
  const [openServices, setOpenServices] = useState(false);
  const [openProducts, setOpenProducts] = useState(false);
  const [openArchitecture, setOpenArchitecture] = useState(false);
  const [scrolling, setScrolling] = useState(false);
  const projectsButtonRef = useRef<HTMLButtonElement>(null);
  const servicesButtonRef = useRef<HTMLButtonElement>(null);
  const productsButtonRef = useRef<HTMLButtonElement>(null);
  const [dropdownPositionProjects, setDropdownPositionProjects] = useState({ top: 0, left: 0 });
  const [dropdownPositionServices, setDropdownPositionServices] = useState({ top: 0, left: 0 });
  const [dropdownPositionProducts, setDropdownPositionProducts] = useState({ top: 0, left: 0 });

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setScrolling(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleClickProjects = () => {
    if (projectsButtonRef.current) {
      const rect = projectsButtonRef.current.getBoundingClientRect();
      setDropdownPositionProjects({ top: rect.bottom, left: rect.left });
    }
    setOpenProjects(!openProjects);
    setOpenServices(false);
    setOpenProducts(false);
  };

  const handleClickServices = () => {
    if (servicesButtonRef.current) {
      const rect = servicesButtonRef.current.getBoundingClientRect();
      setDropdownPositionServices({ top: rect.bottom, left: rect.left });
    }
    setOpenServices(!openServices);
    setOpenProjects(false);
    setOpenProducts(false);
    setOpenArchitecture(false);
  };

  const handleClickProducts = () => {
    if (productsButtonRef.current) {
      const rect = productsButtonRef.current.getBoundingClientRect();
      setDropdownPositionProducts({ top: rect.bottom, left: rect.left });
    }
    setOpenProducts(!openProducts);
    setOpenProjects(false);
    setOpenServices(false);
    setOpenArchitecture(false);
  };

  const handleLinkClick = (route: string) => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  };

  const handleClickArchitecture = () => {
    setOpenArchitecture((prev) => !prev);
  };

  return (
    <AppBar
      position='fixed'
      sx={{
        height: { xs: '64px', sm: '130px' },
        justifyContent: 'center',
        backgroundColor: scrolling ? '#1b1b1b' : 'transparent',
        boxShadow: 'none',
        borderBottom: '1px solid grey',
        transition: 'background-color 0.3s ease-in-out',
      }}
    >
      <Toolbar
        sx={{
          py: { xs: 0.5, sm: 0 },
          minHeight: { xs: 64, sm: 130 },
        }}
      >
        <IconButton size='large' edge='start' aria-label="logo" sx={{ mr: 2, color: 'transparent' }}>
             <Link to='/'>
                <Box
                  component="span"
                  sx={{
                    display: 'block',
                    width: { xs: 48, sm: 120 },
                    height: { xs: 48, sm: 120 },
                    marginLeft: { xs: 0, sm: '20px' },
                    '& img': { width: '100%', height: '100%', objectFit: 'contain', display: 'block' },
                  }}
                >
                  <img
                    src={ZJ}
                    alt="ZJ Associates"
                    onClick={() => handleLinkClick('/')}
                  />
                </Box>
             </Link>
        </IconButton>
        <Box sx={{ flexGrow: 1, justifyContent: 'flex-end', display: { xs: "none", sm: "flex", marginRight: '20px' } }}>
          <Link to='/' style={{ textDecoration: 'none' }}>
            <Button color="primary" className="Menu-items" disableRipple onClick={() => handleLinkClick('/')}>Home</Button>
          </Link>
          <Link to='/aboutpage' style={{ textDecoration: 'none' }}>
            <Button color="primary" className="Menu-items" disableRipple onClick={() => handleLinkClick('/aboutpage')}>About</Button>
          </Link>

          <Button
            ref={projectsButtonRef}
            color="primary"
            className="Menu-items"
            onClick={handleClickProjects}
            disableRipple
            endIcon={openProjects ? <ExpandLess /> : <ExpandMore />}
          >
            Projects
          </Button>
          <Collapse in={openProjects} timeout="auto" unmountOnExit>
            <Paper
              sx={{
                position: 'absolute',
                top: dropdownPositionProjects.top,
                left: dropdownPositionProjects.left,
                zIndex: 1,
                mt: 1,
              }}
            >
              <List component="div" disablePadding>
                {['All', 'Completed', 'Ongoing'].map((subItem) => (
                  <Link
                    key={subItem}
                    to='/projectpage'
                    state={subItem}
                    style={{
                      textDecoration: 'none',
                      color: 'inherit'
                    }}
                  >
                    <ListItem sx={{ pl: 2 }}>
                      <ListItemButton>
                        <ListItemText primary={subItem} sx={{
                          '&:hover': {
                            color: '#c5a47e'
                          }
                        }} />
                      </ListItemButton>
                    </ListItem>
                  </Link>
                ))}
              </List>
            </Paper>
          </Collapse>
{/* // ===========================Services================================= */}
<Button
        ref={servicesButtonRef}
        color="primary"
        className="Menu-items"
        onClick={handleClickServices}
        disableRipple
        endIcon={openServices ? <ExpandLess /> : <ExpandMore />}
      >
        Services
      </Button>
      <Collapse in={openServices} timeout="auto" unmountOnExit>
        <Paper
          sx={{
            position: 'absolute',
            top: dropdownPositionServices.top,
            left: dropdownPositionServices.left,
            zIndex: 1,
            mt: 1,
          }}
        >
          <List component="div" disablePadding>
            <ListItem sx={{ pl: 4 }}>
              <ListItemButton onClick={handleClickArchitecture}>
                <ListItemText primary="Architecture" />
                {openArchitecture ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
            </ListItem>
            <Collapse in={openArchitecture} timeout="auto" unmountOnExit>
              <List component="div" disablePadding sx={{ pl: 4 }}>
                {['Residential', 'Commercial'].map((subItem) => (
                  <Link key={subItem} to="/servicepage" state={subItem} style={{ textDecoration: 'none', color: 'inherit' }}>
                    <ListItem sx={{ pl: 2 }}>
                      <ListItemButton>
                        <ListItemText primary={subItem} />
                      </ListItemButton>
                    </ListItem>
                  </Link>
                ))}
              </List>
            </Collapse>
            {['Interior', 'Construction', 'Urban'].map((subItem) => (
              <Link key={subItem} to="/servicepage" state={subItem} style={{ textDecoration: 'none', color: 'inherit' }}>
                <ListItem sx={{ pl: 2 }}>
                  <ListItemButton>
                    <ListItemText primary={subItem} />
                  </ListItemButton>
                </ListItem>
              </Link>
            ))}
          </List>
        </Paper>
      </Collapse>
          {/* Products dropdown */}
          <Button
            ref={productsButtonRef}
            color="primary"
            className="Menu-items"
            onClick={handleClickProducts}
            disableRipple
            endIcon={openProducts ? <ExpandLess /> : <ExpandMore />}
            aria-expanded={openProducts}
            aria-haspopup="true"
            aria-label="Products menu"
          >
            Products
          </Button>
          <Collapse in={openProducts} timeout="auto" unmountOnExit>
            <Paper
              sx={{
                position: 'absolute',
                top: dropdownPositionProducts.top,
                left: dropdownPositionProducts.left,
                zIndex: 1,
                mt: 1,
              }}
              role="menu"
              aria-label="Products"
            >
              <List component="nav" disablePadding>
                <Link
                  to="/products/pythograss-collection"
                  style={{ textDecoration: 'none', color: 'inherit' }}
                  onClick={() => { setOpenProducts(false); handleLinkClick('/products/pythograss-collection'); }}
                >
                  <ListItem sx={{ pl: 2 }}>
                    <ListItemButton role="menuitem">
                      <ListItemText primary="Pythograss Collection" sx={{ '&:hover': { color: '#c5a47e' } }} />
                    </ListItemButton>
                  </ListItem>
                </Link>
              </List>
            </Paper>
          </Collapse>
{/* //================================================careers================================================ */}
          <Link to='/careers' style={{ textDecoration: 'none' }}>
            <Button color="primary" className="Menu-items" disableRipple onClick={() => handleLinkClick('/contactpage')}>CAREERS</Button>
          </Link>
          <Link to='/contactpage' style={{ textDecoration: 'none' }}>
            <Button color="primary" className="Menu-items" disableRipple onClick={() => handleLinkClick('/contactpage')}>Contact</Button>
          </Link>
          <Link to='/login' style={{ textDecoration: 'none' }}>
            <Button color="primary" className="Menu-items" disableRipple onClick={() => handleLinkClick('/login')}>Login</Button>
          </Link>
        </Box>
        <Box sx={{ display: { xs: "flex", sm: "none" }, flexGrow: 1, justifyContent: 'flex-end' }}>
          <MenuDrawer />
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;
